module.exports = __webpack_public_path__ + "img/Starbucks_case_study_2.6cff5bc0.jpg";